import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogsReturnCode } from 'src/app/enums/dialogs/returnCode.enum';
import { HandlerManager } from 'src/app/managers/handler/handler.manager';
import { LoadingManager } from 'src/app/managers/loading/loading.manager';
import { SessionManager } from 'src/app/managers/session/session.manager';
import { User } from 'src/app/beans/login/user/user.bean';
import { ServiceDetail } from 'src/app/beans/service/service.detail.bean';
import { ServiceCategory } from 'src/app/beans/service/service.category.bean';
import { Result } from 'src/app/beans/result/result.bean';
import { BookNumbering } from 'src/app/beans/bookNumbering/bookNumbering';
import { CustomSelect } from 'src/app/components/select/custom/custom-select/custom.select';
import { ThrowStmt } from '@angular/compiler';

@Component({
  selector: 'service-dialog',
  templateUrl: './service.dialog.html',
  styleUrls: ['./service.dialog.scss'],
})
export class ServiceDialog implements OnInit {
  public _service: ServiceDetail;
  public categories: ServiceCategory[];

  public siteId: number;

  firstById: number = null;
  bookNumbering: CustomSelect;
  @ViewChild('bookNumbering') set _bookNumbering(bookNumbering: CustomSelect) {
    this.bookNumbering = bookNumbering;
  }

  numberingList: BookNumbering[] = null;

  async recoveryNumbering() {
    const user = this._session.user().get();

    if (!User.isKind(user)) return; // TODO handle user incorrect

    this._loader.start();

    let response = null;

    response = await this._handler
      .bookNumbering()
      .list((user as User).token, this.siteId);

    this._loader.stop();

    if (!response) return;
    if (!response.response) return;
    const list = response.response as BookNumbering[];
    this.numberingList = list;
    this.setNumbering();
    return list;
  }

  setNumbering() {
    const numbering = this._service.bookNumbering;
    if (numbering) this.firstById = numbering;
    else this.firstById = 0;
  }

  constructor(
    private dialogRef: MatDialogRef<ServiceDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,

    private _handler: HandlerManager,
    private _loader: LoadingManager,
    private _session: SessionManager
  ) {}

  ngOnInit(): void {
    //Set service
    this._service = this.data.service;

    //Set siteId
    this.siteId = this.data.siteId;
    //Set categories
    this.categories = this.data.categories;

    //Set service to null
    if (!this._service) {
      this._service = {
        id: null,
        name: null,
        code: null,
        catId: null,
        catName: null,
        priority: null,
        ticket: 0,
        booking: 0,
        ticketPrefix: '',
        bookPrefix: '',
        avgTime: null,
        tktReset: null,
        timeFor: null,
        maxSeqTickets: null,
        active: 1,
        bookNumbering: 0,
        timeFraction: 1,
        waitLimit1: null,
        waitLimit2: null,
      };
    } else {
      if (this._service.timeFor == 'Y') this._service.timeFor = 1;
      else this._service.timeFor = 0;
    }
    console.log(this._service);

    this.recoveryNumbering();
  }

  //---------------------------------------------------------------------------------------------------

  async create() {
    this.defaultOperation();

    let response = await this.changeValue('create');

    if (Result.isKind(response) && response.result) {
      this.dialogRef.close({
        code: DialogsReturnCode.SERVICE_OPERATION_ACCEPTED,
      });
    } else this._service.timeFor = this._service.timeFor == 'Y' ? 1 : 0;
  }

  async update() {
    this.defaultOperation();

    let response = await this.changeValue('update');

    if (Result.isKind(response) && response.result) {
      this.dialogRef.close({
        code: DialogsReturnCode.SERVICE_OPERATION_ACCEPTED,
      });
    } else this._service.timeFor = this._service.timeFor == 'Y' ? 1 : 0;
  }

  cancel() {
    this.dialogRef.close({
      code: DialogsReturnCode.OPERATION_DECLINED,
    });
  }

  //---------------------------------------------------------------------------------------------------

  async changeValue(action: string) {
    const user = this._session.user().get();

    if (!User.isKind(user)) return;

    this._loader.start();

    let service = this._service;

    let data: ServiceDetail = {
      id: null,
      name: service.name,
      code: service.code,
      catId: service.catId,
      catName: null,
      priority: service.priority,
      ticket: service.ticket,
      booking: service.booking,
      ticketPrefix: service.ticketPrefix,
      bookPrefix: service.bookPrefix,
      avgTime: service.avgTime,
      tktReset: service.tktReset,
      timeFor: service.timeFor,
      maxSeqTickets: service.maxSeqTickets,
      active: service.active,
      bookNumbering: service.bookNumbering,
      timeFraction: service.timeFraction,
      waitLimit1: service.waitLimit1,
      waitLimit2: service.waitLimit2,
    };

    let response = null;
    if (action === 'create')
      response = await this._handler
        .service()
        .create((user as User).token, this.siteId, data);
    if (action === 'update')
      response = await this._handler
        .service()
        .update((user as User).token, this.siteId, this._service.id, data);

    this._loader.stop();

    return response;
  }

  //---------------------------------------------------------------------------------------------------

  defaultOperation() {
    this._service.tktReset = this._service.tktReset ? 1 : 0;
    this._service.timeFor = this._service.timeFor ? 'Y' : 'N';
    if (this._service.maxSeqTickets < 0) this._service.maxSeqTickets = 0;
    if (this._service.maxSeqTickets > 999) this._service.maxSeqTickets = 999;
    // this._service.maxSeqTickets = this._service.maxSeqTickets ?  1 : 0

    this._service.ticket = this._service.ticket ? 1 : 0;
    this._service.booking = this._service.booking ? 1 : 0;

    if (this._service.ticket == 0) this._service.ticketPrefix = null;
    if (this._service.booking == 0) this._service.bookPrefix = null;
  }

  numberingChange(value: any) {
    console.log('change', value);

    if (value) this._service.bookNumbering = value?.id;
  }
}
